

export const ServerAddress ="https://investo.ir/v1/";
export const ServerChatAddress ="https://chat.investo.ir/v1/";



